import React from 'react';
import moment from 'moment';

export const Month = (props) => {
    const { mon, data } = props;
    const dt = moment(mon).startOf('month');

    const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    let currIdx = 0;
    const weeks = [];
    const currMon = dt.format('M');
    const monYr = `${dt.format('MMMM')} ${dt.format('YYYY')}`;
    let total = 0;
    let totalCount = 0;
    while (currIdx < 42) {
        const pos = currIdx % 7;
        const day = dt.format('ddd');
        const cWIdx = Math.floor(currIdx / 7);
        if (weeks[cWIdx] === undefined) {
            weeks[cWIdx] = [];
        }

        if (dt.format('M') !== currMon) {
            weeks[cWIdx].push(<td key={currIdx}></td>);
            currIdx++;
            continue;
        }

        if (days[pos] !== day) {
            weeks[cWIdx].push(<td key={currIdx}></td>);
            currIdx++;
            continue;
        }
        const dtFmt = dt.format('YYYY-MM-DD');
        const list = data.filter(item => moment(item.date).format('YYYY-MM-DD') === dtFmt);
        const counts = list.length;
        list.sort((a, b) => b.title.localeCompare(a.title));
        weeks[cWIdx].push(<td key={`item_${currIdx}`} className="cal-cell">
            <div>{dt.format('DD')}</div>
            {counts > 0 && <div className="cal-badge">{counts}
                <div className="cal-pop">
                    <ol>
                        {list.map(c => <li key={c.id}><a href={c.url}>{c.title}</a></li>)}
                    </ol>
                </div>
            </div>}
            {counts === 0 && <span className="cal-badge is-empty">-</span>}
        </td>);
        dt.add(1, 'day');
        if (counts > 0) {
            total++;
            totalCount += counts;
        }
        currIdx++;
    }
    return <table className="cal-table">
        <tbody>
            <tr><td className="cal-month-head" colSpan="7"><b>{monYr}</b>
                <span style={{ float: 'right' }}>{total} days · {totalCount}</span></td></tr>
            <tr>{days.map(day => <td key={day}>{day}</td>)}</tr>
            {weeks.map((week, wi) => <tr key={wi}>{week}</tr>)}
        </tbody>
    </table>;
}


export const LinearMonth = (props) => {
    const { months } = props;
    const headers = [<td key="month">Month</td>];
    for (var idx = 1; idx <= 31; idx++) {
        headers.push(<th key={idx}>{idx}</th>);
    }

    const keys = Object.keys(months);
    keys.sort((a, b) => b.localeCompare(a));

    return <table className="cal-table">
        <thead>
            <tr>{headers}</tr>
        </thead>
        <tbody>
            {keys.map((mon, pos) => {
                const data = months[mon];
                const dt = moment(mon).startOf('month');
                let currIdx = 0;
                const currMon = dt.format('M');
                const monYr = `${dt.format('MMM')} ${dt.format('YYYY')}`;
                const dates = [];
                dates.push(<td className="cal-month-head" key={monYr}>{monYr}</td>);
                while (currIdx < 31) {
                    const day = dt.format('ddd');
                    const weekend = (day === 'Sun' || day === 'Sat');
                    if (dt.format('M') !== currMon) {
                        dates.push(<td key={currIdx}></td>);
                        currIdx++;
                        continue;
                    }
                    const dtFmt = dt.format('YYYY-MM-DD');
                    const list = data.filter(item => moment(item.date).format('YYYY-MM-DD') === dtFmt);
                    // An entry may stand in for several items (a day-rollup row
                    // carries its own `count`); without one it counts as itself.
                    const counts = list.reduce((sum, item) => sum + (item.count || 1), 0);

                    const popupStyle = {};
                    if (currIdx > 15) { popupStyle.right = '0px'; popupStyle.left = 'auto'; }
                    if (pos > 7) { popupStyle.bottom = '100%'; popupStyle.top = 'auto'; }

                    list.sort((a, b) => a.title.localeCompare(b.title));

                    dates.push(<td key={`item_${currIdx}`} className={`cal-cell ${weekend ? 'cal-weekend' : ''}`}>
                        {counts > 0 && <div className="cal-badge">{counts}
                            <div className="cal-pop" style={popupStyle}>
                                {day}
                                <ol>
                                    {list.map(c => <li key={c.id}><a href={c.url}>{c.title}</a></li>)}
                                </ol>
                            </div>
                        </div>}
                        {counts === 0 && <span className="cal-badge is-empty">{day[0]}</span>}
                    </td>);
                    dt.add(1, 'day');
                    currIdx++;
                }
                return <tr key={mon}>{dates}</tr>;
            })}
        </tbody>
    </table>;
}
